module.exports = __webpack_public_path__ + "static/media/00_paint_vigud-toscana.580bf911.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/00_paint_vigud-toscana.jpg
// module id = 278
// module chunks = 0